
import { Observable } from './druid/./druid/Observable';
import { count } from './druid/./druid/operator/count';

Observable.prototype.count = count;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    count: typeof count;
  }
}